interface MapGradientLegendProps {
    selectedNetworkType: string;
  };
  
  export default function MapGradientLegend({
    selectedNetworkType
  }: MapGradientLegendProps) {
  
    return (
      <div className={'map-gradient-legend-box'}>
        {/* legend header */}
        <div className={'map-gradient-legend-header'}>
          Heatmap legend [unit in dBm]
        </div>
        <div className={'map-gradient-legend-container'}>
          {/* gradient plot */}
          <div className={'map-gradient-legend'}>
          </div>
          {/* ticks */}
          <div className={'map-gradient-legend-tick-container'}>
            <div className={'map-gradient-legend-tick'} />
            <div className={'map-gradient-legend-tick'} />
            <div className={'map-gradient-legend-tick'} />
            <div className={'map-gradient-legend-tick'} />
            <div className={'map-gradient-legend-tick'} />
          </div>
          {/* labels */}
          <div className={'map-gradient-legend-label-container'}>
            <div className={'map-gradient-legend-label'}>
              {selectedNetworkType === 'cellular' ? -140: -90}
            </div>
            <div className={'map-gradient-legend-label'}>
              {selectedNetworkType === 'cellular' ? -120: -80}
            </div>
            <div className={'map-gradient-legend-label'}>
              {selectedNetworkType === 'cellular' ? -100: -70}
            </div>
            <div className={'map-gradient-legend-label'}>
              {selectedNetworkType === 'cellular' ? -80: -60}
            </div>
            <div className={'map-gradient-legend-label'}>
              {selectedNetworkType === 'cellular' ? -60: -50}
            </div>
          </div>
        </div>
      </div>
    );
  }